import { render } from "./Teleport.vue?vue&type=template&id=28a746ed"
import script from "./Teleport.vue?vue&type=script&lang=ts"
export * from "./Teleport.vue?vue&type=script&lang=ts"
script.render = render

export default script